// removed by extract-text-webpack-plugin
module.exports = {"fixed-donate-button":"_3iUpP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/DonateButton.scss
// module id = ./src/components/Page/DonateButton.scss
// module chunks = 5